<template>
    <div v-if="dataOptions.type ==='select'" class="select-field">
      
      <button @click="clearFields" v-if="dataValuesX !== clearProp && hasClear" class="btn-small waves-effect btn-floating z-depth-0 white clearSelect">
         <i class="material-icons grey-text text-darken-3">close</i>
       </button>
    <div class="input-field"  v-if="dataSource === 'code'">
      <i class="material-icons prefix grey-text text-darken-2" v-if="dataOptions.icon.active" v-html="dataOptions.icon.value"></i>
        <select
          class="valid" :class="{browserDefault: 'browser-default'}"
          :name="dataOptions.label.toLowerCase()"
          :id="dataOptions.label.toLowerCase()"
          v-model="dataValuesX"
        >
          <option
            :value="option"
            :selected="option === dataValuesX"
            v-for="(option, index) in dataOptions.options"
            v-bind:key="index * 2.12231"
          >{{option}}</option>
        </select>
        <label :for="dataOptions.label.toLowerCase()">{{dataOptions.label}}</label>
      </div>
    </div>      
</template>
<script>
import M from 'materialize-css'
export default {
  name:'selectField',
  props:{
    dataSource:{
      type:String,
      default:'code'
    },
    hasClear:{
      type: Boolean,
      default: false,
    },
    clearProp:{
      type: [String, Boolean],
      default: false
    },
    browserDefault: {
      type: Boolean,
      default: false,
    },
    dataClass:{
      type: String,
      default:''
    },
    currentValue:{
      type: [String,Boolean],
    },
    dataOptions:{
      type:[Array, Object]
    }
  },
  data(){
    return{
       dataValues:'',
      selectInstances:false,
    }
  },
  computed:{
    
  dataValuesX:{
    get () {
        return this.currentValue ? this.currentValue : this.dataValues
      },
    set (e) {
     this.$_updateValues(e)
    }
  },
  },
  watch:{
    'dataClass': function (/* nV */){
    //  window.console.log(nV)
    }
  },
  mounted(){
  this.dataValues = this.dataOptions.values
    setTimeout(() => {
        this.$_initFormFields()
    });
  },
  beforeDestroy(){
    this.selectInstances
    ? this.selectInstances.destroy()
    : false
  },
  methods:{
    clearFields () {
      this.$_updateValues(this.clearProp)
      this.$el.querySelector('input').value = this.clearProp
    },
    $_updateValues(e){
      let v = e ? e : this.dataValuesX
      this.$emit('update',{values:v,property:this.dataOptions.propName})
    },
    $_updateValuesWeb(){
      this.$emit('update',{values:this.dataValues,property:this.dataOptions.input_prop})
    },
    $_initFormFields() {
      let elems = this.$el.querySelector("select");
      this.selectInstances = M.FormSelect.init(elems);
    }
  }
}
</script>
<style scoped lang="scss">
.select-field {
  position: relative;
  
.clearSelect {
    position: absolute;
    right: -4px;
    top: 24px;
    z-index: 9;
}
}
</style>